import { Injectable } from '@angular/core';
import { graphqlOperation } from '@aws-amplify/api-graphql';
import { generateClient } from 'aws-amplify/api';
import { UserProfile } from '../models';
import { APIService, CountByReadStatusQuery, ModelSortDirection, UpdateNotificationInput } from './appsync.service';
import { HelperService } from './helper.service';
import { LocalStorageService } from './local-storage.service';
import { UltiService } from './ulti.service';
const API = generateClient();


@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  counterUnread = -1;
  notifications: Array<any> = [];
  loaded = false;
  LIMIT_NOTIFICATION = 30;
  LIMIT_LOAD_MORE = 5;
  readded: boolean;
  userProfile: UserProfile;
  nextToken: string;
  rawNotifications: any = [];
  latestNotification: any;
  constructor(
    private localStorageService: LocalStorageService,
    private apiService: APIService,
    private ultiService: UltiService
  ) {
    this.userProfile = this.localStorageService.getUserProfile();
    if (!this.userProfile?.sub) {
      return;
    }
    const subscription = this.apiService.OnChangeNotificationListener(this.userProfile.sub);
    subscription.subscribe({
      next: (sourceData: any) => {
        const itemUpdated = sourceData?.value?.data?.onChangeNotification;
        this.notifications.forEach(notification => {
          const readded = notification?.items.find(item => item.id === itemUpdated.id);
          if (readded) {
            readded.readStatus = 'true';
          }
        });
        this.getCounterUnread();
      }
    });
   }

  async getCounterUnread(): Promise<any> {
    const counterRead = await this.getCounterRead();
    this.counterUnread = counterRead?.scannedCount;
  }

  loadMoreNotification(): void {
    if (this.loaded) {
      this.getNotifications();
    }
  }

  reset(): void {
    this.loaded = true;
  }

  async getNotifications(): Promise<any> {
    if (this.latestNotification) { return; }
    try {
      this.loaded = false;
      const res = await this.apiService.ListNotifications(undefined, this.LIMIT_NOTIFICATION, this.nextToken, undefined, ModelSortDirection.DESC);
      res?.items?.forEach(notification => {
        notification && (notification.message = this.ultiService.replaceHexCode(notification?.message));
      })

      this.nextToken = res?.nextToken as string;
      if (!this.nextToken) {
        this.latestNotification = true;
      }

      this.rawNotifications = [...this.rawNotifications, ...(res?.items ?? [])];
      this.notifications = HelperService.groupByDate(this.rawNotifications);
      this.loaded = true;
    } catch (error) {
    }
  }

  async getNotificationsTest(): Promise<any> {
    if (this.latestNotification) { return; }
    try {
      this.loaded = false;
      const filter = {createdAt: {between: ['2023-01-05T13:07:11.763Z', '2023-01-05T14:09:02.607Z']}}
      // const filter = null
      // const filter = { createdAt: { eq: '2023-01-05T13:07:11.763Z' }}
      const res = await this.apiService.ListNotifications(undefined, this.LIMIT_NOTIFICATION, this.nextToken, filter, ModelSortDirection.ASC);
      console.log(res);

      this.nextToken = res?.nextToken as string;
      if (!this.nextToken) {
        this.latestNotification = true;
      }

      this.rawNotifications = [...this.rawNotifications, ...(res?.items ?? [])];
      this.notifications = HelperService.groupByDate(this.rawNotifications);
      this.loaded = true;
    } catch (error) {
    }
  }

  async updateNotification(id): Promise<any> {
    const params: UpdateNotificationInput = {
      id,
      readStatus: 'true'
    }
    this.apiService.UpdateNotification(params);
  }

  async getCounterRead(): Promise<any> {
    const statement = `query CountByReadStatus($readStatus: String) {
      countByReadStatus(readStatus: $readStatus) {
         scannedCount
      }
    }`;
    const response = (await API.graphql(
      graphqlOperation(statement, { readStatus: 'false' })
    )) as any;
    return <CountByReadStatusQuery>response.data.countByReadStatus;
  }
}
